import React from "react";
import ResourseButtons from "../../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import TextAreaField from "../../../components/form/TextAreaField";
import { addPDOProposalApprove } from "../../../features/projectsSlice";
import { useNavigate } from "react-router-dom";
import InputField from "../../../components/form/InputField";
import { closeModal } from "../../../features/modalSLice";
import { useNotification } from "../../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import { addPDOProposalLetterSchema } from "../../../schemas";

const AddPDOPlanningApproval = ({ id, name }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const addNotification = useNotification();
  const loading = useSelector(
    (state) => state.projects.load.addPDOProposalApprove
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: zodResolver(addPDOProposalLetterSchema) });

  const onSubmit = async (data) => {
    try {
      const res = await dispatch(addPDOProposalApprove(data));
      if (addPDOProposalApprove.fulfilled.match(res)) {
        dispatch(closeModal());
        addNotification("Proposal approved successfully!", "success");
        return navigate("/requests/pdo-approvals");
      } else {
        addNotification(res.payload.message, "error");
        if (res.payload.code === 412) {
          dispatch(closeModal());
          navigate("/requests/pdo-approvals");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  return (
    <>
      {id && (
        <div className="min-w-[85vw] sm:min-w-[35rem] lg:min-w-[50rem] max-w-3xl w-full text-text-1/80">
          <div className="flex flex-col justify-center items-center gap-2 py-5 border-b border-bkg2 mb-4 ">
            <h4>Approve Proposal</h4>
          </div>
          <p className="font-extrabold ">{name}</p>
          <form
            onSubmit={handleSubmit(onSubmit)}
            method="post"
            encType="multipart/form-data"
          >
            <InputField
              name="subject"
              label="Subject"
              errors={errors.subject}
              register={register}
              autoComplete="off"
              type="text"
            />
            <TextAreaField
              register={register}
              label="Comment"
              name="comment"
              errors={errors.comment}
            />
            <InputField
              type="text"
              register={register}
              label="Reference Number"
              name="reference_id"
              autoComplete="off"
              errors={errors.reference_id}
            />

            <InputField
              register={register}
              name="id"
              defaultValue={id}
              type="hidden"
            />
            <ResourseButtons loading={loading} />
          </form>
        </div>
      )}
    </>
  );
};

export default AddPDOPlanningApproval;
